{
  "stats": {
    "title": "Device status",
    "connection": "Connection",
    "noConnection": "No connection",
    "unknown": "Unkonwn",
    "inactive": "Inactive",
    "sync": "Synchronized",
    "syncError": "Synchronization error"
  },
  "alarms": {
    "title": "Alarms",
    "info": "Info",
    "warning": "Warning",
    "error": "Error"
  },
  "attacks": {
    "title": "Last {{count}} attacks"
  },
  "charts": {
    "title": "Top {{count}} utilization devices"
  }
}